export default "__VITE_ASSET__CnTxV3wP__"